import React from "react";
import { useTranslation } from "react-i18next";
import { useFormErrors } from "helpers/useFormErrors";

import InnerInput from "components/inputs/InnerInput/InnerInput";
import cn from "clsx";
import styles from "./RiskKycPresetTab.module.scss";
import SwitchBtn from "components/buttons/SwitchBtn";
import { RiskKycPresetItem } from "store/risk/kyc/presets/slice";

type Props = {
  payload: Partial<RiskKycPresetItem>;
  handleUpdateField: (
    key: keyof RiskKycPresetItem,
    value: RiskKycPresetItem[keyof RiskKycPresetItem]
  ) => void;
  formError: ReturnType<typeof useFormErrors>;
  readOnly?: boolean;
}


const RiskKycPresetMain: React.FC<Props> = ({
  payload,
  handleUpdateField,
  formError,
  readOnly
}) => {
  const { t } = useTranslation();

    
  return (
    <div className={cn("out-notif-content", styles.presetsTabContainer)}>
      <div className={styles.mainFieldsRow}>
        <div className="out-notif-form-box--item">
          <InnerInput
            value={payload?.code ?? ""}
            placeholder={t("presetCode")}
            label={t("presetCode")}
            type="text"
            id="kycPresetCode"
            onChange={(v) => {
              handleUpdateField('code', v);
              formError.clearFieldError('code');
            }}
            isRequired
            hasError={formError.hasError('code')}
            disabled={readOnly}
            tooltipText={t("presetCodeExplanation")}
            tooltipPosition="top-left"
          />
        </div>
        <div className="out-notif-form-box--item">
          <InnerInput
            value={payload?.title ?? ""}
            placeholder={t("Title")}
            label={t("title")}
            type="text"
            id="kycPresetTitle"
            onChange={(v) => {
              handleUpdateField('title', v);
              formError.clearFieldError('title')
            }}
            hasError={formError.hasError('title')}
            isRequired
            disabled={readOnly}
          />
        </div>
        <div className={cn("bonus-form-box--item", styles.presetsTabSwitcher)}>
          <SwitchBtn
            activeTxt={t("active")}
            notActiveTxt={t("hidden")}
            isActive={!!payload?.isActive}
            handleClick={() => {
              handleUpdateField(
                "isActive",
                payload?.isActive ? !payload?.isActive : true,
              );
            }}
            disabled={readOnly}
          />
        </div>
      </div>
      <div className="bonus-form-box--item">
        <InnerInput
          maxCodePoints={2500}
          value={payload.description ?? ""}
          placeholder={t("enterText")}
          label={t("description")}
          type="textarea"
          rows={7}
          id="kycPresetDescription"
          onChange={(e) => {
            handleUpdateField("description", e);
          }}
          disabled={readOnly}
          tooltipText={t("presetOptionalDescription")}
          tooltipPosition="top-left"
        />
      </div>
    </div>
    
  );
};

export default RiskKycPresetMain;
